import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { NavLink } from 'react-router-dom';
import Pagination from '@material-ui/lab/Pagination';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiPaginationItem-outlined': {
      borderColor: theme.palette.success.main,
      color: theme.palette.success.main,
    },
    '& .Mui-selected': {
      // backgroundColor: theme.palette.success.main,
      backgroundColor: '#175E82',
      color: theme.palette.common.white,
    },
    '& .MuiPaginationItem-page:hover': {
      // backgroundColor: theme.palette.success.light,
      backgroundColor: ' #2594cc',
      color: theme.palette.common.white,
    },
  },
}));

function PaginationComponent({
  cardsPerPage,
  totalCards,
  paginate,
}) {
  const classes = useStyles();
  const pageNumbers = [];
  const lastPage = Math.ceil(totalCards / cardsPerPage);
  for (let i = 1; i <= lastPage; i += 1) {
    pageNumbers.push(i);
  }

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      alignContent="center"
    >
      <Grid item xs={12}>
        <Pagination
          count={lastPage}
          shape="rounded"
          variant="text"
          color="primary"
          onChange={(e, value) => paginate(value)}
          className={classes.root}
        />
      </Grid>
    </Grid>
  );
}

export default PaginationComponent;
